const { GET_CITIZEN_USERS } = require("src/actions/types");

const initialState = { CitizensList: [] };

const ManageCitizenReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_CITIZEN_USERS:
      return {
        ...state,
        CitizensList: payload,
      };
    default:
      return state;
  }
};

export { ManageCitizenReducer };
